import {PdsWidget} from './pds-widget';
import {PdsError} from './interfaces/pds-error';
import { PdsImage } from './interfaces/pds-image';
export class PdsErrorPage extends PdsWidget {

  is = 'pds-error-page';

  error: PdsError;

  imagePath: string;
  useImagePath = false;

  alternateImage: PdsImage;

  homePageRedirectCallback: () => void;
  letUsKnowCallback: () => void;

  properties = {
    alternateImage: {
      type: Object,
      value: null
    }
  };

  attached(): void {
    setTimeout(() => {
      this.imagePath = `./img/error-assets/${this.error.statusCode}.png`;
    });
  }

  invokePrimaryAction(): void {
    if (this.homePageRedirectCallback != null) {
      this.homePageRedirectCallback();
    }
  }

  invokeSecondaryAction(): void {
    if (this.letUsKnowCallback != null) {
      this.letUsKnowCallback();
    }
  }
}
